import Rgpd from './Rgpd.jsx';

export default Rgpd;